import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
let SearchEngineManagementService = class SearchEngineManagementService {
    constructor(searchEngineManagementApi) {
        this.searchEngineManagementApi = searchEngineManagementApi;
        // #region company
        this.getCompaniesSolr = this.searchEngineManagementApi.getCompaniesSolr;
        this.createCompaniesIndex = this.searchEngineManagementApi.createCompaniesIndex;
        this.deleteCompaniesIndex = this.searchEngineManagementApi.deleteCompaniesIndex;
        this.createCompanyIndexEs = this.searchEngineManagementApi.createCompanyIndexEs;
        this.deleteCompanyIndexEs = this.searchEngineManagementApi.deleteCompanyIndexEs;
        this.setCompaniesReindex = this.searchEngineManagementApi.setCompaniesReindex;
        // #region
        this.getEmailSolr = this.searchEngineManagementApi.getEmailSolr;
        this.delAccountsIndex = this.searchEngineManagementApi.delAccountsIndex;
        this.createAccountsIndex = this.searchEngineManagementApi.createAccountsIndex;
        this.createAccountIndexEs = this.searchEngineManagementApi.createAccountIndexEs;
        this.deleteAccountIndexEs = this.searchEngineManagementApi.deleteAccountIndexEs;
        this.setAccountsReindex = this.searchEngineManagementApi.setAccountsReindex;
        this.refreshCompanyUsersIndex = (companyId) => {
            return this.searchEngineManagementApi.refreshCompanyUsersIndex(companyId);
        };
        this.postPackagesIndex = () => {
            return this.searchEngineManagementApi.postPackagesIndex();
        };
        this.deletePackagesIndex = () => {
            return this.searchEngineManagementApi.deletePackagesIndex();
        };
        this.postPackagesReindex = () => {
            return this.searchEngineManagementApi.postPackagesReindex();
        };
        this.postGroupsIndex = () => {
            return this.searchEngineManagementApi.postGroupsIndex();
        };
        this.deleteGroupsIndex = () => {
            return this.searchEngineManagementApi.deleteGroupsIndex();
        };
        this.postGroupsReindex = () => {
            return this.searchEngineManagementApi.postGroupsReindex();
        };
        this.postGroupsMembersIndex = () => {
            return this.searchEngineManagementApi.postGroupsMembersIndex();
        };
        this.deleteGroupsMembersIndex = () => {
            return this.searchEngineManagementApi.deleteGroupsMembersIndex();
        };
        this.postGroupsMembersReindex = () => {
            return this.searchEngineManagementApi.postGroupsMembersReindex();
        };
    }
};
SearchEngineManagementService = __decorate([
    injectable(),
    __param(0, inject(Symbols.SearchEngineManagementApi)),
    __metadata("design:paramtypes", [Object])
], SearchEngineManagementService);
export { SearchEngineManagementService };
